// @flow

/**
 * Detect if given number is almost an int value
 * @param value number
 * @returns {boolean} true if value is nearly an int value, false otherwise
 */
export const isNearlyInt = (value: ?number): boolean => {
  if (value) {
    const rounded = Math.round(value);
    const diff = Math.abs(value - rounded);
    return diff < 0.01;
  }
  return false;
};
